// extracted by mini-css-extract-plugin
export var configurationSection = "_ro-0";